import axios from "axios";

export const getAll = async () =>
  axios({
    method: "GET",
    url: `${process.env.REACT_APP_BACKEND_URL}/v1/entries`,
  });
